import { ga } from '../../../engine/ga-sidecar'
import { l } from '../../../engine/lodash'
import { websockets } from '../../../engine/websockets-sidecar'
import { clickEater } from '../../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import type { IChessUiGButton } from './chessUiGButtons'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiGraphicsUtils } from './chessUiGraphicsUtils-sidecar'
import { chessUiMenuMain } from './chessUiMenuMain-sidecar'
import { chessUiPrompt } from './chessUiPrompt-sidecar'

interface IChessUiMultiListGames extends IChessUiCanvas {
  isRefreshing: boolean
  buttonsGames: IChessUiGButton[]
  lastListLength: number
  pageNumber: number
  gameFilter: string
}
let _obj: IChessUiMultiListGames | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    createButtons()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 600
  let th = 700

  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiDialog)
  canvas.autoOffset = false

  let obj: IChessUiMultiListGames =
    chessUiCanvas.assign<IChessUiMultiListGames>(canvas, {
      isRefreshing: false,
      buttonsGames: [],
      lastListLength: 0,
      pageNumber: 0,
      gameFilter: '',
    })

  // voyageUiCanvas

  // obj.buttons = [
  //   voyageUiGButtons.create('Ok', 50, 50, () => {
  //     get().onOk()
  //     setOpen(false)
  //   }),
  // ]

  return obj
}

function setPage(pageNum: number, gameFilter: string) {
  let obj = get()
  if (obj.pageNumber !== pageNum || gameFilter !== obj.gameFilter) {
    obj.pageNumber = pageNum
    obj.gameFilter = gameFilter
    createButtons()
  }
}

const createButtons = () => {
  let obj = get()
  obj.buttons = [
    chessUiGButtons.create('Cancel', 50, 50, () => {
      ga.action('click', 'join-cancel')
      setOpen(false)
    }),
    chessUiGButtons.create('Refresh', 250, 50, () => {
      ga.action('click', 'join-refresh')

      obj.isRefreshing = true
      setPage(0, '')
    }),
    chessUiGButtons.create('Host New', 450, 50, () => {
      ga.action('click', 'join-host-new')
      setOpen(false)
      chessUiMenuMain.setOpen(false)
      chessUiMenuMain.setBackgroundOpen(false)
      websockets.setSingleplayer(false)
      websockets.hostChannel('')
    }),

    chessUiGButtons.create('Next', 450, 50, () => {
      ga.action('click', 'join-next')
      setPage(obj.pageNumber + 1, obj.gameFilter)
    }),
    chessUiGButtons.create('Search', 450, 50, () => {
      ga.action('click', 'join-search')

      chessUiPrompt.setText('Search for?', '', '')
      chessUiPrompt.setOpen(true, (filter) => {
        filter = filter.trim()
        if (filter) {
          setPage(0, filter)
        } else {
          setPage(0, '')
        }
        console.log('search for', "'" + filter + "'")
      })
    }),
  ]

  let perPage = 10 * 1

  let list = l.cloneDeep(websockets.getGameList())
  list = l.sortBy(list, (c) => c.numPlayers)

  let gf = obj.gameFilter.toLowerCase()

  if (gf) {
    list = l.filter(list, (c) => c.key.toLowerCase().includes(gf))
  }

  let x = 0
  let y = 0

  for (let i = 0; i < perPage; i++) {
    let idx = obj.pageNumber * perPage + i
    if (idx < list.length) {
      let c = list[idx]
      let spacer = '      '
      let text = c.key + spacer + 'Players: ' + c.numPlayers + ''
      if (c.hasPassword) {
        text += spacer + 'Private'
      }
      let b = chessUiGButtons.create(text, x, y, () => {
        ga.action('click', 'join-game')

        if (c.hasPassword) {
          chessUiPrompt.setText('Password?', '', '')
          chessUiPrompt.setOpen(true, (password) => {
            setOpen(false)
            websockets.joinChannel(c.key, false, password)
          })
        } else {
          setOpen(false)
          websockets.joinChannel(c.key, false, '')
        }
      })
      b.w = 500
      obj.buttons.push(b)
    }
  }
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(chessFonts.get().f, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 0.4)
    obj.texts.push(_text)
    return _text
  }

  g.clear()

  let gb = chessCamera.getGameBounds()

  g.fillStyle(0x222222, 0.67)
  g.fillRect(0, 0, gb.width, gb.height)

  let w = obj.targetWidth
  let h = obj.targetHeight

  let x = (gb.width - w) / 2
  let y = (gb.height - h) / 2

  chessUiGraphicsUtils.bevelPanel(g, x, y, w, h)

  let title = addText('Open games', x + 6, y)
  stevieTexts2.setScale(title, 0.6)

  // let textDesc = addText(obj.textDesc, x + 6 + 20, y + 40)
  // stevieTexts2.setWrapWidth(textDesc, obj.targetWidth - 50)

  x += 20
  y += h - 60
  obj.buttons[0].x = x
  obj.buttons[0].y = y
  obj.buttons[1].x = x + 200
  obj.buttons[1].y = y
  obj.buttons[1].text = obj.isRefreshing ? '...' : 'Refresh'
  obj.buttons[2].x = x + 400
  obj.buttons[2].y = y

  obj.buttons[3].x = x + 400
  obj.buttons[3].y = y - 80
  obj.buttons[4].x = x
  obj.buttons[4].y = y - 80

  x = (gb.width - w) / 2 + 20
  y = (gb.height - h) / 2 - 20
  // y += 50

  let yo = 0
  let xo = 0
  l.forEach(obj.buttons, (c, cIdx) => {
    if (cIdx < 5) {
      return
    }

    if (yo >= 500) {
      yo = 0
      xo += 200
    }
    yo += 50

    c.x = x + xo
    c.y = y + yo
  })

  chessUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean, onOk = () => {}) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
  obj.isRefreshing = isOpen
  // obj.onOk = onOk
  if (isOpen) {
    update()
  }
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    if (obj.isRefreshing) {
      if (websockets.isStillConnecting()) {
        obj.isRefreshing = true
      } else {
        websockets.refreshGameList()
        obj.isRefreshing = false
      }
    }

    let list = websockets.getGameList()
    if (obj.lastListLength !== list.length) {
      obj.lastListLength = list.length
      createButtons()
    }

    chessUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    chessUiCanvas.clear(obj)
  }
}
